import { setup } from "web/entrypoints/common/setup";
import "./css-feature-article";
import { featureArticleComponents } from "./feature-article";

setup(featureArticleComponents);
